
export const ApckDashboardSidebar = {
    props: {
        alertsEnabled: {
            type: Boolean,
            required: false,
            default: true
        },
        alertsSrc: {
            type: String,
            required: true,
            default: '/alerts'
        },
        newsEnabled: {
            type: Boolean,
            required: false,
            default: true
        },
        newsSrc: {
            type: String,
            required: true,
            default: '/news'
        },
    },
    template: `
        <div class="dashboard-sidebar">
            <apck-alerts-panel v-if="alertsEnabled" :class="['tour-alerts', newsEnabled ? '' : 'full-height']" :src="alertsSrc"/>
            <apck-news-and-updates v-if="newsEnabled" class="tour-updates" :src="newsSrc"/>
        </div>
    `
}